const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.NUTRITIONAL_PARAMETER)

export const apiNutritionalParameters = {
	fetchNutritionalParameters: async (
		page: number = 1,
		perPage: number = 50,
	): Promise<IApiResponseModel<INutritionalParameterModel[]>> => {
		const { data, meta } = await apiCommon<INutritionalParameter[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }),
		})

		return { data: data.map(d => NutritionalParameter(d)), meta }
	},
}
